import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  dropdownList: [{
    disabled: true,
    heading: 'heading1',
    subHeading: 'subHeading1',
    value: 'value1'
  }, {
    heading: 'heading2',
    subHeading: 'subHeading2',
    value: 'value2'
  }, {
    heading: 'heading3',
    subHeading: 'subHeading3',
    value: 'value3'
  }, {
    heading: 'heading4',
    subHeading: 'subHeading4',
    value: 'value4'
  }, {
    heading: 'heading5',
    subHeading: 'subHeading5',
    value: 'value5'
  }, {
    heading: 'heading6',
    subHeading: 'subHeading6',
    value: 'value6'
  }],
  placeholder: 'search',
  label: 'label',
  postfixIconName: 'DownChevronIcon',
  variant: 'radio',
  variantPosition: 'left',
  filterKey: 'heading'
}, getTestId('DropdownWidgetContainer'));